import React, { useEffect, useState } from 'react'
import { SyncOutlined } from '@ant-design/icons'
import { Card, Col, Button, notification, Row, Select } from 'antd'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { fetchSphereFlagsList, updateSphereEventFlags, filterEventsByFlag } from '~actions'
import { getCurrentUser } from '~context'

import { MultiSelect, PageLayout } from '~stories'

import './BulkFlagUploader.modules.css'

const PAGE_TITLE = 'Bulk Flag Uploader'
const { Option } = Select

const NOTIFICATION_MESSAGES = {
  UNAUTHORIZED: 'You are not authorized to perform this action.'
}

const BulkFlagUploader = ({
  fetchSphereFlagsList,
  flagsList,
  allEvents: allEventsProps,
  selectedEvents: selectedEventsProps,
  updateSphereEventFlags,
  filterEventsByFlag,
  message,
  success
}) => {
  const [errorMessage, setErrorMessage] = useState(null)
  const [isDataLoaded, setIsDataLoaded] = useState()
  const [sphereFlags, setSphereFlags] = useState([])
  const [selectedFlag, setSelectedFlag] = useState()
  const [selectedFlagIndex, setSelectedFlagIndex] = useState()
  const { access_token: accessToken, userDetails: { isContentEditor } } = getCurrentUser()
  const [allEvents, setAllEvents] = useState()
  const [selectedEvents, setSelectedEvents] = useState([])

  useEffect(() => {
    setIsDataLoaded(false)
    fetchSphereFlagsList()
  }, [fetchSphereFlagsList])

  useEffect(() => {
    if (flagsList) {
      setIsDataLoaded(true)
      setSphereFlags(flagsList)
    }
  }, [flagsList])

  console.log(flagsList, selectedFlag, selectedFlagIndex)
  const onSubmitHandler = async (event) => {
    event.preventDefault()
  }
  useEffect(() => {
    if (allEventsProps) {
      setAllEvents(allEventsProps)
      setIsDataLoaded(true)
    }
  }, [allEventsProps])

  useEffect(() => {
    if (success) {
      setIsDataLoaded(true)
      notification.info({ message: message })
      setTimeout(() => {
        window.location.reload()
      }, 1500)
    } else if (!success && message) {
      setIsDataLoaded(true)
      notification.error({ message: message })
    }
  }, [success, message])

  useEffect(() => {
    if (selectedEventsProps) {
      setSelectedEvents(selectedEventsProps)
      setIsDataLoaded(true)
    }
  }, [selectedEventsProps])

  const managePageLists = (items, source, dest, sourceFn, destFn) => {
    const selectedItems = Array.isArray(items)
      ? items
      : [items]
    const clonedSource = [...source]
    let clonedDest = [...dest]
    selectedItems.forEach(item => {
      const selectedEventIndex = clonedSource.findIndex(event => event?.title === item?.title)
      const [itemToMove] = clonedSource.splice(selectedEventIndex, 1)
      clonedDest = [...clonedDest, itemToMove]
    })
    sourceFn([...clonedSource])
    destFn([...clonedDest])
  }

  const onListAdd = (selectedEvent, allEvents, selectedEvents, setallEvents, setSelectedEvents) => {
    managePageLists(selectedEvent, allEvents, selectedEvents, setallEvents, setSelectedEvents)
  }

  const onListRemove = (selectedEvent, allEvents, selectedEvents, setallEvents, setSelectedEvents) => {
    managePageLists(selectedEvent, selectedEvents, allEvents, setSelectedEvents, setallEvents)
  }

  const onListFilter = (allListItems, filterValue) => {
    const testRegExp = new RegExp(filterValue, 'i')
    return allListItems.filter(item => {
      const title = `${item?.title}`
      return testRegExp.test(title)
    })
  }

  const handleSubmit = () => {
    if (!isContentEditor) {
      notification.error({ message: NOTIFICATION_MESSAGES.UNAUTHORIZED })
      return
    }
    updateSphereEventFlags({
      selectedFlag,
      selectedEvents
    }, accessToken)
  }

  return (
    <PageLayout title={PAGE_TITLE}>

      { errorMessage ? <div className="error-message">{errorMessage}</div> : null }

      <form noValidate onSubmit={(event) => onSubmitHandler(event).catch(err => setErrorMessage(err.msg))}>

        <div className="form-flag-row">
          <Select
            allowClear
            onChange={(value) => {
              const flagTitle = flagsList[value] ? flagsList[value].title : null
              setSelectedFlag(flagsList[value])
              setSelectedFlagIndex(value)
              if (flagTitle) {
                filterEventsByFlag({ flag: flagTitle })
              }
            }}
            onClear={() => {
              setSelectedFlag()
              setSelectedFlagIndex(-1)
            }}
            placeholder='Select Flags'
            style={{ width: '300px' }}
            value={selectedFlagIndex}
          >
            {
              sphereFlags.map((venueLogo, index) => <Option key={index} value={index}>{venueLogo.title}</Option>)
            }
          </Select>
          <br />
          <br />
          <Card title="">
            <Row>
              <Col span={14}>
                <MultiSelect
                  availableListItems={allEvents}
                  displayField="title"
                  onAdd={(items) => onListAdd(items, allEvents, selectedEvents, setAllEvents, setSelectedEvents)}
                  onFilter={onListFilter}
                  onRemove={(items) => onListRemove(items, allEvents, selectedEvents, setAllEvents, setSelectedEvents)}
                  resourceName="Events"
                  selectedListItems={selectedEvents}
                  valueField='_id'
                />
              </Col>
            </Row>
          </Card>
        </div>

        <div className="form-row">
          <Button disabled={!selectedFlag} onClick={handleSubmit} {...(!isDataLoaded ? { loading: { icon: <SyncOutlined spin /> } } : {})} type="primary">
            Upload
          </Button>
        </div>
      </form>

    </PageLayout>
  )
}

const mapStateToProps = ({ sphereFlags }) => ({
  flagsList: sphereFlags.flagsList,
  allEvents: sphereFlags.allEvents,
  selectedEvents: sphereFlags.selectedEvents,
  message: sphereFlags.message,
  success: sphereFlags.success
})

const mapDispatchToProps = {
  fetchSphereFlagsList,
  updateSphereEventFlags,
  filterEventsByFlag
}

BulkFlagUploader.propTypes = {
  allEvents: PropTypes.array,
  fetchSphereFlagsList: PropTypes.func,
  filterEventsByFlag: PropTypes.func,
  flagsList: PropTypes.array,
  message: PropTypes.string,
  selectedEvents: PropTypes.array,
  success: PropTypes.bool,
  updateSphereEventFlags: PropTypes.func
}

BulkFlagUploader.defaultProps = {

}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BulkFlagUploader)
